
import axios from "axios";

// apiFunctions.js
export async function fetchData(url) {
    try {
        const response = await axios.get(url);
        const responseData = await response.data;
        
        return responseData;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    
  }
  